import type { FC, ReactElement } from 'react';
import { memo, useState } from 'react';

import { Button, Dialog, DialogContent, DialogContentText, DialogTitle, Grid } from '@mui/material';

import UpdatePasswordForm from 'common/viewcomp/forms/update_password_form';

import './changepass.modal.scss';

interface Props {
    t: Function;
    onClose: () => void;
    open: boolean;
}

const _ChangePassModal: FC<Props> = (props): ReactElement => {
    const { t, open, onClose } = props;

    const [submitting, setSubmit] = useState(false);

    const handleFormSubmitStatus = (): void => {
        setSubmit(true);
    };

    if (!open) {
        return <></>;
    }

    return (
        <Dialog open={open} onClose={onClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">{t('changepass.title')}</DialogTitle>
            <DialogContent>
                <DialogContentText>{t('changepass.description')}</DialogContentText>

                <UpdatePasswordForm onSubmit={handleFormSubmitStatus} submitting={submitting}>
                    {(disableButton): ReactElement => (
                        <div className="button_group">
                            <Grid container spacing={2}>
                                <Grid item>
                                    <Button
                                        disabled={disableButton}
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                        id="changePassButton"
                                    >
                                        {t('changepass.submit_button')}
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button id="cancel" onClick={onClose}>
                                        {t('changepass.cancel_button')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </div>
                    )}
                </UpdatePasswordForm>
            </DialogContent>
        </Dialog>
    );
};

export default memo(_ChangePassModal, (prevProps, nextProps): boolean => nextProps.open === prevProps.open);
